var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-content"},[_c('span',{staticClass:"filter-title"},[_vm._v(_vm._s(_vm.$t('filter.category.label')))]),_vm._v(" "),_c('mobile-dialog',{on:{"openChange":function($event){_vm.hideFields = $event}}}),_vm._v(" "),(!_vm.hideFields)?_c('dynamic-fields'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79fe413a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/MenuFilters.vue
// module id = 933
// module chunks = 12